import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { useScreenInit } from '../useScreenInit';
const blogPosts = [{
  id: 1,
  title: 'Top 5 Signature Cocktails for Summer Weddings',
  excerpt: 'Discover the most requested and refreshing bespoke cocktails that are guaranteed to keep your wedding guests cool and celebrating all night long.',
  category: 'Weddings',
  date: 'June 12, 2026',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800'
}, {
  id: 2,
  title: 'The Art of the Perfect Mocktail: Sophistication Without the Spirits',
  excerpt: "Why alcohol-free doesn't mean flavor-free. Learn how we craft elegant, botanical-infused mocktails that impress both the eye and the palate.",
  category: 'Mixology',
  date: 'May 28, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/hDZQatreQxFVWfc1uwrHoh/Image_(49).jpg'
}, {
  id: 3,
  title: 'Elevating Corporate Events with a Custom Mobile Bar',
  excerpt: 'Move beyond the standard wine and beer table. See how a bespoke cocktail experience can boost networking, impress clients, and elevate your brand.',
  category: 'Corporate',
  date: 'May 15, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/5yN64wqTPGjWVnhgLzAFWw/Image_(55).jpg'
}, {
  id: 4,
  title: 'Pairing Gourmet Desserts with Signature Sips',
  excerpt: 'A guide to creating the perfect harmony between our rich, bite-sized sweets and our custom-crafted cocktails for an unforgettable finish to your event.',
  category: 'Pairings',
  date: 'April 30, 2026',
  image: 'https://cdn.magicpatterns.com/uploads/wVm7kHz2wF77pb8aL32vqL/Image_(46).jpg'
}];
export function Blog() {
  useScreenInit();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-[#050505] selection:bg-[#992f74] selection:text-white font-montserrat flex flex-col" data-id="element-208">
      <Header data-id="element-209" />

      <main className="flex-grow pt-24 pb-16" data-id="element-210">
        {/* Blog Header */}
        <div className="max-w-7xl mx-auto px-6 mb-12 text-center" data-id="element-211">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-212">
            <h1 className="text-5xl md:text-7xl font-montserrat font-black italic text-[#992f74] mb-6" data-id="element-213">
              The Pour
            </h1>
            <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto font-light" data-id="element-214">
              Insights, inspiration, and stories from behind the bar. Elevate
              your event planning with our expert mixology and hospitality tips.
            </p>
          </motion.div>
        </div>

        {/* Featured Post (First Post) */}
        <div className="max-w-7xl mx-auto px-6 mb-16" data-id="element-215">
          <Link to={`/blog/${blogPosts[0].id}`} data-id="element-216">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="group relative grid grid-cols-1 lg:grid-cols-2 gap-0 bg-[#111] border border-white/10 rounded-2xl overflow-hidden hover:border-[#992f74]/50 transition-colors duration-500 cursor-pointer" data-id="element-217">
              <div className="relative h-[400px] lg:h-auto overflow-hidden" data-id="element-218">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-219"></div>
                <img src={blogPosts[0].image} alt={blogPosts[0].title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000" data-id="element-220" />
              </div>
              <div className="p-10 md:p-16 flex flex-col justify-center" data-id="element-221">
                <div className="flex items-center gap-4 mb-6" data-id="element-222">
                  <span className="text-[#992f74] text-xs font-bold tracking-widest uppercase" data-id="element-223">
                    {blogPosts[0].category}
                  </span>
                  <span className="text-white/40 text-xs" data-id="element-224">
                    {blogPosts[0].date}
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-white mb-6 group-hover:text-[#992f74] transition-colors duration-300 leading-tight" data-id="element-225">
                  {blogPosts[0].title}
                </h2>
                <p className="text-white/70 leading-relaxed mb-8" data-id="element-226">
                  {blogPosts[0].excerpt}
                </p>
                <div className="mt-auto" data-id="element-227">
                  <span className="inline-flex items-center text-sm font-bold tracking-widest uppercase text-white group-hover:text-[#992f74] transition-colors" data-id="element-228">
                    Read Article <span className="ml-2" data-id="element-229">→</span>
                  </span>
                </div>
              </div>
            </motion.div>
          </Link>
        </div>

        {/* Post Grid */}
        <div className="max-w-7xl mx-auto px-6" data-id="element-230">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" data-id="element-231">
            {blogPosts.slice(1).map((post, idx) => <Link key={post.id} to={`/blog/${post.id}`} data-id="element-232">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: idx * 0.1
            }} className="group flex flex-col bg-[#0A0A0A] border border-white/5 rounded-xl overflow-hidden hover:border-[#992f74]/30 transition-all duration-500 hover:-translate-y-2 cursor-pointer h-full" data-id="element-233">
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-234">
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-235"></div>
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000" data-id="element-236" />
                  </div>
                  <div className="p-8 flex flex-col flex-grow" data-id="element-237">
                    <div className="flex items-center justify-between mb-4" data-id="element-238">
                      <span className="text-[#992f74] text-[10px] font-bold tracking-widest uppercase" data-id="element-239">
                        {post.category}
                      </span>
                      <span className="text-white/40 text-[10px]" data-id="element-240">
                        {post.date}
                      </span>
                    </div>
                    <h3 className="text-xl font-montserrat font-bold text-white mb-4 group-hover:text-[#992f74] transition-colors duration-300 leading-snug" data-id="element-241">
                      {post.title}
                    </h3>
                    <p className="text-white/60 text-sm leading-relaxed mb-6 flex-grow" data-id="element-242">
                      {post.excerpt}
                    </p>
                    <span className="text-xs font-bold tracking-widest uppercase text-white/50 group-hover:text-white transition-colors" data-id="element-243">
                      Read More
                    </span>
                  </div>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-244" />
    </motion.div>;
}